import React from 'react';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';





export default function Home() {
  useEffect(() => {
  AOS.init({ duration: 600, once: false });
  }, []);

  return (
    
    <div className="appContainer">
      <header className="heroSection">
        <h1>Cale Miller</h1>
        <p>software developer | student | lifelong learner</p>
        <a href="#contactSection" className="ctaButton">Contact Me</a>
      </header>

      <section className="aboutSection" id="aboutSection">
        <h2>About Me</h2>
        <p>
          I'm a passionate Computer Science and Artificial Intelligence student focusing on Software Engineering. I strive to learn as much about the field as possible to build my skillset and experiences. My primary strengths include Python (with Django), C# (.NET), JavaScript (Node.js), React, and HTML/CSS. I also have foundational experience with Java, C++, and Lua.
        </p>
      </section>

      <section className='skillsSection' id='skillsSection'>
        <h2>
          Primary Skills
        </h2>
        <ul className='skillsList' data-aos="fade-up">
          <li>Python</li>
          <li>C#</li>
          <li>Django</li>
          <li>Rest Frameworks</li>
          <li>.NET</li>
          <li>React</li>
          <li>JavaScript</li>
          <li> Html/CSS</li>
        </ul>
      </section>

      <section className="projectsSection" id="projectsSection">
        <h2>Projects</h2>
        <div className="projectList" data-aos="fade-up">
          <Link className="projectCard" to="/videoPlayer">
            <h3>Video Player</h3>
            <p>A program allowing users to upload, browse, and watch mp4s from other users.</p>
          </Link>
          <Link className="projectCard" to="/portfolio">
            <h3>Portfolio Site</h3>
            <p>A simple webapp using React to serve as a personal portfolio.</p>
          </Link>
        </div>
      </section>

      <section className="contactSection" id="contactSection">
        <h2>Contact</h2>
        <p>Email: calemiller76@gmail.com</p>
        <p>Phone: (402)-504-2208</p>
        <p>Github profile: <a className='link' href='https://github.com/cmiller12312'>cmiller12312</a></p>
      </section>

      <footer className="footerSection">
      </footer>
    </div>
  );
}
